import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import DialogActions from "@material-ui/core/DialogActions";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import Fab from "@material-ui/core/Fab";
import { useStyles } from '../gnp-modal/component-styles';


function GnpModalGeneric({ children, typeModal, ...props }) {
  const classes = useStyles();

  const validateCloseModal=()=> {
    if (props.disableBackdropClick && reason === "backdropClick") {
      return false;
    }
  
    if (props.disableEscapeKeyDown && reason === "escapeKeyDown") {
      return false;
    }
  
    if (typeof props.onClose === "function") {
      props.onClose;
    }
  }

  return (
    <Dialog
      {...props}
      className={classes[`${props.mobileQuery ? props.nameQuery : typeModal}`]}
      onClose={validateCloseModal}
    >
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent>
        <Fab onClick={props.onClose} size="small">
          <CloseOutlinedIcon />
        </Fab>
        {children}
      </DialogContent>
      <DialogActions>
        <Link onClick={props.onClickCancel} component="button">
          {props.textButtonCancel}
        </Link>
        <Button
          onClick={props.onClickAcepted}
          disabled={props.buttonConfirmDisabled}
        >
          {props.textButtonConfirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
GnpModalGeneric.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
GnpModalGeneric.defaultProps = {
  typeModal: PropTypes.oneOf(["defaultModal"]),
  onClose: () => {}
};

export default GnpModalGeneric;



// WEBPACK FOOTER //
// ./src/controllers/gnp-modal/index.jsx